
const getEnv = () => {
    const host = window.location.hostname.toLowerCase();

    if ( host.includes( 'localhost' ) || host.includes( 'qa.' ) ) {
        return 'qa.';
    }
    
    if ( host.includes( 'pprd.' ) ) {
        return 'pprd.';
    }
    
    return '';
};

export const buildGraphqlServerUri = ( env ) => `https://${ getEnv() }api.biw.cloud/v1/learning-exp/graphql`;
 